const PERMISSION_KEY= "notification:notification_type";
const PAGE_URL = {
    NOTIFICATION_TYPE_PAGE: "/admin/notification/notification-type"
}

export {PERMISSION_KEY, PAGE_URL}

